module.exports = __webpack_public_path__ + "static/media/bg.1d3261af.jpg";